import {React,  useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import { CreateContainer, Header, MainContainer, Order } from './components'
import {AnimatePresence} from 'framer-motion'


const App = () => {


  return (
    <AnimatePresence exitBeforeEnter>
          <div className=''>
            <Header/>
            <main className=''>
              <Routes>
                <Route path='/*' element={<MainContainer />}  />
                {/* <Route path='/createItem' element={<CreateContainer />}/>
                <Route path='/profile' element={<Profile />}/>
                <Route path='/orders' element={<Order />}/> */}
              </Routes>
            </main>
          </div>
    </AnimatePresence>

  )
}

export default App